const mutations = {
  SET_NAV_INDEX(state, data) {
    state.navbarState = data;
  },
  TOGGLE_SIDEBAR(state) {
    state.sidebarCollapsed = !state.sidebarCollapsed;
  },
  SET_SIDEBAR_COLLAPSED(state, data) {
    state.sidebarCollapsed = data;
  },
  LOGIN(state, data) {
    state.isLogin = true;
    localStorage.setItem("accesstoken", data);
  },

  RESET(state) {
    state.navbarState = "0";
    state.pageName = "차트";
    state.email = null;
    state.name = null;
    state.role = null;
    state.isLogin = false;
    state.isAdmin = false;
    state.lnbVisible = false;
    state.gnbVisible = false;
    state.footerVisible = false;
    state.artistList = [];
    state.apiList = [];
    state.channelList = [];
    state.contentsList = [];
    state.userList = [];
    state.clientList = [];
    state.projectList = [];
    state.codeList = [];
    state.contractorList = [];
    state.contractList = [];
    state.albumList = [];
    state.songList = [];
    state.sidebarCollapsed = false;
    state.artist = {
      artist_id: null,
    };
    state.projectList = [];
  },
  LOGOUT() {
    localStorage.removeItem("accesstoken");
  },
  SET_USER_INFO(state, data) {
    if (data.email) {
      state.email = data.email;
      localStorage.setItem("email", data.email);
    }
    if (data.role) {
      state.role = data.role;
      localStorage.setItem("role", data.role);
    }
    if (data.name) {
      state.name = data.name;
    }
    if (data.menu) {
      //state.menu = data.menu;
      state.menu = data.menu;
    }
    if (data.service) {
      //state.service = data.service;
      state.service = data.service;
    }
  },
  SET_LNB_VISIBLE(state, data) {
    state.lnbVisible = data;
  },
  SET_FOOTER_VISIBLE(state, data) {
    state.footerVisible = data;
  },
  SET_GNB_VISIBLE(state, data) {
    state.gnbVisible = data;
  },
  SET_PAGENAME(state, data) {
    state.pageName = data;
  },
  SET_API_LIST(state, data) {
    state.apiList = data;
  },
  SET_CHANNEL_LIST(state, data) {
    state.channelList = data;
  },
  SET_CONTENTS_LIST(state, data) {
    state.contentsList = data;
  },
  SET_ARTIST_LIST(state, data) {
    state.artistList = data;
  },
  SET_USER_LIST(state, data) {
    state.userList = data;
  },
  SET_CLIENT_LIST(state, data) {
    state.clientList = data;
  },
  SET_PROJECT_LIST(state, data) {
    state.projectList = data;
  },
  SET_ARTIST(state, artist_id) {
    let data = state.artistList.find((item) => item.artist_id === artist_id);
    state.artist = data;
    state.artist_id = artist_id;
  },
  SET_CODE_LIST(state, data) {
    state.codeList = data;
  },
  SET_CONTRACTOR_LIST(state, data) {
    state.contractorList = data;
  },
  SET_CONTRACT_LIST(state, data) {
    state.contractList = data;
  },
  SET_ALBUM_LIST(state, data) {
    state.albumList = data;
  },
  SET_SONG_LIST(state, data) {
    state.songList = data;
  },
  SET_CONTRACT_LIST_BY_CONTRACTOR(state, contractListByContractor) {
    state.contractListByContractor = contractListByContractor;
  },
};
export default mutations;
